'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Link$PvpcontrollerWeb = require("./Link.js");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Changelog$PvpcontrollerWeb = require("./Changelog.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var MobileDetect$PvpcontrollerWeb = require("../MobileDetect.js");
var WeaponService$PvpcontrollerWeb = require("../services/WeaponService.js");
var WeaponCardGrid$PvpcontrollerWeb = require("./WeaponCardGrid.js");
var DashboardService$PvpcontrollerWeb = require("../services/DashboardService.js");

var baseChangelogLoading_0 = Css.display("flex");

var baseChangelogLoading_1 = {
  hd: Css.alignItems(Css.center),
  tl: {
    hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
    tl: {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: /* [] */0
    }
  }
};

var baseChangelogLoading = {
  hd: baseChangelogLoading_0,
  tl: baseChangelogLoading_1
};

function changelogLoading(changelogStartSize) {
  return Curry._1(Css.style, {
              hd: Css.height(Css.px(Math.imul(74, changelogStartSize))),
              tl: baseChangelogLoading
            });
}

var changelogLink = Curry._1(Css.style, {
      hd: Css.display(Css.block),
      tl: {
        hd: Css.width({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.fontSize(Css.px(20)),
          tl: {
            hd: Css.marginTop(Css.px(20)),
            tl: {
              hd: Css.marginBottom(Css.px(20)),
              tl: {
                hd: Css.textAlign(Css.center),
                tl: {
                  hd: Css.color(Theme$PvpcontrollerWeb.subTitleColor),
                  tl: {
                    hd: Css.cursor(Css.pointer),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

function changelogLoading$1(changelogStartSize) {
  return Curry._1(Css.style, {
              hd: Css.height(Css.px(Math.imul(144, changelogStartSize))),
              tl: baseChangelogLoading
            });
}

function Dashboard(Props) {
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setWeaponListState = match[1];
  var weaponListState = match[0];
  var match$1 = React.useState(function () {
        return /* Loading */0;
      });
  var changelogState = match$1[0];
  React.useEffect((function () {
          return WeaponService$PvpcontrollerWeb.getHighestDamageWeapons(52, (function (weapons) {
                        if (weapons.TAG === /* Ok */0) {
                          var weapons$1 = weapons._0;
                          return Curry._1(setWeaponListState, (function (_previousState) {
                                        return /* Loaded */{
                                                _0: weapons$1
                                              };
                                      }));
                        }
                        var err = weapons._0;
                        if (err.RE_EXN_ID === "Match_failure") {
                          var match = err._1;
                          Debugging$PvpcontrollerWeb.messageWithData("Dashboard-PvpcontrollerWeb" + (":getHighestDamageWeapons Could not destructure weapon type. Failed at " + match[0] + ":L" + String(match[1]) + "_C" + String(match[2]) + "."), {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        } else {
                          Debugging$PvpcontrollerWeb.messageWithData("Dashboard-PvpcontrollerWeb:getHighestDamageWeapons Could not get weapons", {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        }
                        return Curry._1(setWeaponListState, (function (_previousState) {
                                      return /* LoadingFailed */1;
                                    }));
                      }));
        }), []);
  var changelogStartSize = MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? 3 : 5;
  var changelogClass = changelogState === 0 ? (
      MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? changelogLoading$1(changelogStartSize) : changelogLoading(changelogStartSize)
    ) : "";
  return React.createElement("div", undefined, React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Recently changed"), React.createElement("div", {
                  className: changelogClass
                }, React.createElement(Changelog$PvpcontrollerWeb.make, Changelog$PvpcontrollerWeb.makeProps(DashboardService$PvpcontrollerWeb.getRecentChangelog, undefined, changelogState, match$1[1], changelogStartSize, undefined, undefined, undefined, undefined))), React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("/changelog", changelogLink, "View full changelog", undefined, undefined, undefined, undefined)), React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Weapons by highest damage"), React.createElement("div", {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    justifyContent: "center"
                  }
                }, typeof weaponListState === "number" ? (
                    weaponListState !== 0 ? React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined)) : React.createElement(WeaponCardGrid$PvpcontrollerWeb.Fake.make, WeaponCardGrid$PvpcontrollerWeb.Fake.makeProps(52, undefined, undefined))
                  ) : React.createElement(WeaponCardGrid$PvpcontrollerWeb.make, WeaponCardGrid$PvpcontrollerWeb.makeProps(weaponListState._0, undefined, undefined))));
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = Dashboard;

exports.makeProps = makeProps;
exports.make = make;
/* baseChangelogLoading Not a pure module */
